import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=d55fa324&scoped=true&"
import script from "./FormTemplate.vue?vue&type=script&lang=js&"
export * from "./FormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=d55fa324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55fa324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d55fa324')) {
      api.createRecord('d55fa324', component.options)
    } else {
      api.reload('d55fa324', component.options)
    }
    module.hot.accept("./FormTemplate.vue?vue&type=template&id=d55fa324&scoped=true&", function () {
      api.rerender('d55fa324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FormTemplate.vue"
export default component.exports